import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import './ClaimTracker.css';

import {loadClaimStory,
  loadUserSendingInList,
  loadUserSentPackageList,
  loadRecordList,
  loadRecordError,
  updateClaimNumber,
  loadClaimInfo,
   loadClaimNumberRecords
} from 'ducks/claimtracker';

import {loadRegisteredRecordOverview,
  loadDeRegisteredRecordOverview,
  updateRepresentative} from 'ducks/ddupload';

import 'react-tabs/style/react-tabs.css';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';

import ClaimStory from "./Claim/ClaimStory";
import UserSendingInTable from "./Batch/UserSendingInTable";
import BatchTable from "./Batch/BatchTable";
import BatchRecords from "./Batch/BatchRecords";
import RecordErrorTable from "./Batch/RecordErrorTable";
import TrackModal from "./Modals/TrackModal";
import ClaimInfo from "./Claim/ClaimInfo";
import ClaimNumberRecordTable from "./ClaimNumber/ClaimNumberRecordTable";
import ClaimOverViewTable from "./Overview/ClaimOverViewTable";

import Button from 'jsx/elements/buttons/Button';

class ClaimTrackerPage extends React.Component {
  state = {
    displayErrorModal : false,
    displayClaimIDModal : false,
    displayClaimNumberModal : false,
    user : {},
    batch : {},
    record : {},
    claimID : 0,
    claimNumber: '',
    tabIndex : 0,
  };

  constructor(props){
    super(props);
    this.onUserSelect = this.onUserSelect.bind(this);
    this.onBatchSelect = this.onBatchSelect.bind(this);
    this.onClaimIDSelect = this.onClaimIDSelect.bind(this);
    this.onClaimNumberSelect = this.onClaimNumberSelect.bind(this);
    this.onTrackIDErrorSelect = this.onTrackIDErrorSelect.bind(this);
    this.onGetClaimIDRecords = this.onGetClaimIDRecords.bind(this);

    this.onHandleTextChange = this.onHandleTextChange.bind(this);
    this.onHandleTextChange2 = this.onHandleTextChange2.bind(this);

    this.onCloseModal = this.onCloseModal.bind(this);

    this.props.loadUserSendingInList();
    // this.props.loadUserSentPackageList(5069);
    // this.props.loadRecordList(21, 1);
    // this.props.loadRecordList(84, 2);
    // this.props.loadRecordError(14094);
    //this.props.loadClaimNumberRecords('1000000006200159500003268710000102076TR01000000102076');
  }

  onHandleTextChange(event){
    this.setState({claimNumber : event.target.value});
  };

  onHandleTextChange2(event){
    this.setState({claimID : event.target.value});
  };


  onGetClaimNumberRecords = () => {
    //console.debug("DODO", this.state.claimNumber);
    //this.props.loadClaimNumberRecords(this.state.claimNumber);
    this.props.updateClaimNumber(this.state.claimNumber);
  };


  onGetClaimIDRecords = () => {
    //console.debug("DODO", this.state.claimNumber);
    //this.props.loadClaimNumberRecords(this.state.claimNumber);
    this.props.loadClaimStory(this.state.claimID).then(()=>{
      this.props.loadClaimInfo(this.state.claimID);
    });
  };

  onCloseModal = () => {
    //console.debug("onCloseModal");
    this.setState({displayErrorModal : false});
    this.setState({displayClaimIDModal : false});
    this.setState({displayClaimNumberModal : false});
  };

  onUserSelect = (e, user) => {
    console.debug("onUserSelect", e, user);
    this.setState({user : user});
    this.props.loadUserSentPackageList(user.sentBy);
    this.props.updateRepresentative(user.representativeRegno);

    this.props.loadRegisteredRecordOverview(user.representativeRegno);
    this.props.loadDeRegisteredRecordOverview(user.representativeRegno);
  };

  onBatchSelect = (e, batch) => {
    console.debug("onBatchSelect", batch.batchID);
    this.props.loadRecordList(batch.batchID, 1).then(()=>
      this.props.loadRecordList(batch.batchID, 2).then(()=>{
        this.setState({batch : batch});
      }));
  };

  onClaimIDSelect = (e, record) => {
    this.setState({record : record});
    this.props.loadClaimStory(record.claimID).then(()=>{
      this.setState({displayClaimIDModal : true});
    });
  };



  onClaimNumberSelect = (e, record) => {
    this.setState({record : record});
    this.setState({claimNumber : record.claimNumber});
    this.props.updateClaimNumber(record.claimNumber).then(()=>{
      this.setState({tabIndex : 1});
    });
    // this.props.loadClaimNumberRecords(record.claimNumber).then(()=>{
    //   this.setState({displayClaimNumberModal : true});
    // });
  };

  onTrackIDErrorSelect = (e, record) => {
    this.setState({record : record});
    this.props.loadRecordError(record.trackID).then(()=>{
      this.setState({displayErrorModal : true});
    });
  };

  render() {
    return (
      <section className="section">
        <div className="padded calc-section">
          <div className="col s1of1">
            <Tabs selectedIndex={this.state.tabIndex} onSelect={tabIndex => this.setState({ tabIndex })} >
              <TabList>
                <Tab>Upload</Tab>
                <Tab>Claim number</Tab>
                <Tab>Claim ID</Tab>
                {this.props.representativeRegno && <Tab>Skráðar færslur</Tab>}
                {this.props.representativeRegno &&<Tab>Afskráðar færslur</Tab>}
              </TabList>
              <TabPanel>
                <div className="grid tight collapse840">
                  <div className="col s1of3">
                    <UserSendingInTable list={this.props.userSendingInList} onClick={this.onUserSelect} />
                    <br/>
                    <BatchTable user={this.state.user} list={this.props.packageList} onClick={this.onBatchSelect}/>
                  </div>
                  <div className="col s2of3">
                    <BatchRecords user={this.state.user} batch={this.state.batch} registerRecordList={this.props.registerRecordList}  deRegisterRecordList={this.props.deRegisterRecordList} onClaimIDClick={this.onClaimIDSelect} onClaimNumberClick={this.onClaimNumberSelect} onErrorClick={this.onTrackIDErrorSelect}/>
                  </div>
                </div>
              </TabPanel>
              <TabPanel>
              <div className="grid tight collapse840">
                <div className="col s1of3">
                  <div className="calc-dates-box calc-div-inline">
                    <div className="calc-div-inline calc-div-inline-space">
                      <label htmlFor="editClaimNumber" >Kröfunúmer (ekki ClaimID)</label> <input id="editClaimNumber" value={this.state.claimNumber} onChange={this.onHandleTextChange} type="text"/>&nbsp;&nbsp;
                      <Button className="getclaimnumber-button" text="Sækja færslur" onClick={this.onGetClaimNumberRecords} />
                    </div>
                  </div>
                </div>
              </div>
              <br/>
              <ClaimNumberRecordTable list={this.props.claimNumberRecordList} onClaimIDClick={this.onClaimIDSelect} onErrorClick={this.onTrackIDErrorSelect}/>
            </TabPanel>

              <TabPanel>
                <div className="grid tight collapse840">
                  <div className="col s1of3">
                    <div className="calc-dates-box calc-div-inline">
                      <div className="calc-div-inline calc-div-inline-space">
                        <label htmlFor="editClaimID" >Kröfunúmer (ekki ClaimID)</label> <input id="editClaimID" value={this.state.claimID} onChange={this.onHandleTextChange2} type="text"/>&nbsp;&nbsp;
                        <Button className="getclaimnumber-button" text="Sækja færslur" onClick={this.onGetClaimIDRecords} />
                      </div>
                    </div>
                  </div>
                </div>
                <hr/>
                {this.props.claimInfo && <h3>ClaimID {this.props.claimInfo.claimID}</h3>}
                <div className="grid tight collapse840">
                  <div className="col s2of3">
                    <ClaimStory claimStoryList={this.props.claimStoryList}/>
                  </div>
                  <div className="col s1of3">
                    <ClaimInfo data={this.props.claimInfo}/>
                  </div>
                </div>
              </TabPanel>

              {this.props.representativeRegno && <TabPanel>
                <ClaimOverViewTable list={this.props.registerRecordOverviewList} onClaimIDClick={this.onClaimIDSelect} onClaimNumberClick={this.onClaimNumberSelect} onErrorClick={this.onTrackIDErrorSelect}/>
              </TabPanel>}
              {this.props.representativeRegno && <TabPanel>
                <ClaimOverViewTable list={this.props.deRegisterRecordOverviewList} onClaimIDClick={this.onClaimIDSelect} onClaimNumberClick={this.onClaimNumberSelect} onErrorClick={this.onTrackIDErrorSelect}/>
              </TabPanel>}
            </Tabs>
          </div>
        </div>


        <TrackModal isOpen={this.state.displayErrorModal} onCloseModal={this.onCloseModal}>
          <span>Track ID {this.state.record.trackID} </span>
          <RecordErrorTable list={this.props.errorRecordList}/>
        </TrackModal>
        <TrackModal isOpen={this.state.displayClaimIDModal} onCloseModal={this.onCloseModal}>
          <span>Claim ID {this.state.record.claimID} </span> <span>Track ID {this.state.record.trackID} </span>
          <ClaimStory claimStoryList={this.props.claimStoryList}/>
        </TrackModal>
        {/*<TrackModal isOpen={this.state.displayClaimNumberModal} onCloseModal={this.onCloseModal}>*/}
          {/*<span>ClaimNumber {this.state.record.claimNumber}</span>*/}
          {/*<ClaimNumberRecordTable list={this.props.claimNumberRecordList}/>*/}
        {/*</TrackModal>*/}
      </section>
    );
  }
}

ClaimTrackerPage.propTypes = {
  claimStoryList : PropTypes.array,
  userSendingInList : PropTypes.array,
  packageList : PropTypes.array,
  registerRecordList : PropTypes.array,
  deRegisterRecordList : PropTypes.array,
  claimNumberRecordList : PropTypes.array,
  errorRecordList : PropTypes.array,
  claimInfo : PropTypes.object
};

const mapState = ({ claimtracker, ddupload }) => ({
  claimStoryList : claimtracker.claimStoryList,
  userSendingInList : claimtracker.userSendingInList,
  packageList : claimtracker.packageList,
  registerRecordList : claimtracker.registerRecordList,
  deRegisterRecordList : claimtracker.deRegisterRecordList,
  claimNumberRecordList : claimtracker.claimNumberRecordList,
  errorRecordList : claimtracker.errorRecordList,
  registerRecordOverviewList : ddupload.registerRecordOverviewList,
  deRegisterRecordOverviewList : ddupload.deRegisterRecordOverviewList,
  representativeRegno : ddupload.representativeRegno,
  claimInfo : claimtracker.claimInfo,
});

const mapDispatch = dispatch => ({
  // openModal: bindActionCreators(openModal, dispatch),
  loadClaimStory: bindActionCreators(loadClaimStory, dispatch),
  loadUserSendingInList: bindActionCreators(loadUserSendingInList, dispatch),
  loadUserSentPackageList: bindActionCreators(loadUserSentPackageList, dispatch),
  loadRecordList: bindActionCreators(loadRecordList, dispatch),
  loadRecordError: bindActionCreators(loadRecordError, dispatch),
  loadClaimNumberRecords: bindActionCreators(loadClaimNumberRecords, dispatch),
  loadRegisteredRecordOverview : bindActionCreators(loadRegisteredRecordOverview, dispatch),
  loadDeRegisteredRecordOverview : bindActionCreators(loadDeRegisteredRecordOverview, dispatch),
  updateRepresentative : bindActionCreators(updateRepresentative, dispatch),
  updateClaimNumber : bindActionCreators(updateClaimNumber, dispatch),
  loadClaimInfo : bindActionCreators(loadClaimInfo, dispatch),
});

export default withRouter(connect(mapState, mapDispatch)(ClaimTrackerPage));




// WEBPACK FOOTER //
// ./src/pages/ClaimTracker/index.js